"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentContextReadyState;
(function (ComponentContextReadyState) {
    ComponentContextReadyState[ComponentContextReadyState["Loaded"] = 1] = "Loaded";
    ComponentContextReadyState[ComponentContextReadyState["Loading"] = 2] = "Loading";
})(ComponentContextReadyState = exports.ComponentContextReadyState || (exports.ComponentContextReadyState = {}));
//# sourceMappingURL=IComponentContext.js.map